import React from 'react'
// import styled from 'styled-components'
import { TwitterIcon, FacebookIcon, WhatsappIcon,LinkedinIcon,EmailIcon } from "react-share";



import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton
//   EmailShareButton
} from 'react-share';
const shareurl = window.location.href;
const SocialMediaButtons = (props) => (
  <div className="social-icons-container" text={props.text}>
    <FacebookShareButton
      url={props.url}
      quote={props.text}>
      <FacebookIcon size={32} round={true}></FacebookIcon>
    </FacebookShareButton>
    <WhatsappShareButton
      url={props.url}
      subject={props.text}
      quote={props.text}>
      <WhatsappIcon size={32} round={true}></WhatsappIcon>
    </WhatsappShareButton>

    <TwitterShareButton
      url={props.url}
      title={props.text}>
      <TwitterIcon size={32} round={true} />
    </TwitterShareButton>

    <LinkedinShareButton
      url={props.url}
      title={props.text}>
      <LinkedinIcon size={32} round={true} />
    </LinkedinShareButton>
    <EmailShareButton
      subject={"BeWise - "+props.text}
      body=""
      url={props.url}
      >
      <EmailIcon size={32} round={true}></EmailIcon>  
    </EmailShareButton>
  </div>
)

export default SocialMediaButtons
